<template>
  <div
    id="kt_modal_licenca_fatura_receber"
    ref="kt_modal_licenca_fatura_receber"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header p-3 bg-light">
          <h4 class="modal-title">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Receber Fatura
          </h4>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row">
            <div
              v-if="this.errosGerais && this.errosGerais.Message"
              class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
            >
              <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                <inline-svg src="media/icons/duotune/general/gen044.svg" />
              </span>
              <div class="d-flex flex-stack flex-grow-1">
                <div class="fw-bold">
                  <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                  <div class="fs-6 text-gray-600">
                    {{ this.errosGerais.Message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-4">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-2"
            >
              <div
                class="border rounded bg-light p-3"
                v-if="this.licencaFatura"
              >
                <span
                  class="text-muted text-hover-primary fw-semibold text-muted d-block fs-9"
                >
                  {{ getDescricaoRelacionado(this.licencaFatura) }}
                </span>
                <span
                  class="text-gray-900 fw-bold text-hover-primary mb-1 fs-6"
                >
                  {{ getNomeRelacionado(this.licencaFatura) }}
                </span>
                <span
                  class="text-muted text-hover-primary fw-semibold text-muted d-block fs-7"
                >
                  {{
                    this.$utils.setMask(
                      getDocumentoRelacionado(this.licencaFatura),
                      "##.###.###/####-##",
                      true
                    )
                  }}
                </span>
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-2"
            >
              <div
                class="border rounded bg-light p-3"
                v-if="this.licencaFatura"
              >
                <span
                  class="text-muted text-hover-primary fw-semibold text-muted d-block fs-9"
                >
                  Vencimento
                </span>
                <span
                  class="text-gray-900 fw-bold text-hover-primary mb-1 fs-6"
                >
                  {{ this.$utils.formatarData(this.licencaFatura.vencimento) }}
                </span>
                <span
                  class="text-gray-900 text-muted text-hover-primary fw-semibold text-muted d-block fs-7"
                >
                  R$ {{ this.$utils.formatarNumero(this.licencaFatura.valor) }}
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-2"
            >
              <label class="required form-label">Espécie de Pagamento</label>
              <select
                class="form-select"
                aria-label="Espécie de pagamento"
                v-model="this.licencaFatura.especie"
              >
                <option value="Dinheiro">Dinheiro</option>
                <option value="Boleto Bancário">Boleto Bancário</option>
                <option value="PIX">PIX</option>
                <option value="Transferência Bancária">
                  Transferência Bancária
                </option>
                <option value="Cartão de Crédito">Cartão de Crédito</option>
                <option value="Cartão de Débito">Cartão de Débito</option>
                <option value="Cheque">Cheque</option>
                <option value="Cheque Pré-datado">Cheque Pré-datado</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["especie"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-4"
            >
              <label class="required form-label">Data Pagamento</label>
              <el-date-picker
                :id="`pagamento`"
                v-model.sync="this.licencaFatura.pagamento"
                type="datetime"
                name="dtpDataPagamento"
                placeholder="Selecione uma data"
                format="DD/MM/YYYY"
                size="large"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["pagamento"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-4"
            >
              <label class="form-label required">Valor Recebido</label>
              <CurrencyInput
                class="form-control mb-2"
                placeholder="Valor Recebido R$"
                style="text-align: right"
                v-model="this.licencaFatura.valor_recebido"
                :options="options"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["valor_recebido"] }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            :id="`btnConfirmar`"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import {
  hideModal,
  getOrCreateInstanceModal,
  hideModalId,
} from "@/core/helpers/dom";
const toast = useToast();
import CurrencyInput from "@/components/text/CurrencyInput";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapState } from "vuex";

export default {
  emits: [
    "exibirReceberLicencaFaturaModal",
    "confirmarReceberLicencaFaturaModal",
  ],
  components: {
    CurrencyInput,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  props: {
    id: { type: Number, required: true },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = [];
      this.loading = true;
      if ((await this.validar()) === true) {
        try {
          this.licencaFatura.Emitente = null;
          this.licencaFatura.Revenda = null;
          this.licencaFatura.Distribuidor = null;
          this.licencaFatura.DistribuidorMaster = null;
          this.licencaFatura.id_usuario_recebeu = this.user.User.id;
          this.licencaFatura.data_recebimento = new Date();

          let formData = this.$utils.convertModelToFormData(this.licencaFatura);
          let retPut = await this.$store.dispatch(
            "licencaRecebivel/putLicencaRecebivel",
            formData
          );
          if (retPut.Success === true) {
            toast.success("Fatura recebida com sucesso!", {
              timeout: 3000,
            });
            this.$emit("confirmarReceberLicencaFaturaModal", false);
            hideModal(this.$refs.kt_modal_licenca_fatura_receber);
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      } else {
        await Swal.fire({
          text: "Verifique os avisos antes de prosseguir!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn fw-bold btn-warning",
          },
        });
      }
      this.loading = false;
    },
    async validar() {
      this.errosGerais = [];

      if (!this.licencaFatura) {
        this.errosGerais.Message =
          "O valor recebido da fatura deve ser maior que zero!";
        return false;
      } else if (this.licencaFatura.valor_recebido <= 0) {
        this.errosGerais.Message =
          "O valor recebido da fatura deve ser maior que zero!";
        return false;
      } else if (!this.licencaFatura.pagamento) {
        this.errosGerais.Message = "A data de pagamento deve ser informada!";
        return false;
      } else if (!this.licencaFatura.especie) {
        this.errosGerais.Message = "A espécie de pagamento deve ser informada!";
        return false;
      } else if (this.licencaFatura.especie.length <= 0) {
        this.errosGerais.Message = "A espécie de pagamento deve ser informada!";
        return false;
      }

      return true;
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_licenca_fatura_receber);
      this.$emit("exibirReceberLicencaFaturaModal", false);
    },
    getDescricaoRelacionado(data) {
      if (data.Revenda) {
        return "Revenda";
      } else if (data.Emitente) {
        return "Emitente";
      } else if (data.Distribuidor) {
        return "Distribuidor";
      } else if (data.DistribuidorMaster) {
        return "Distribuidor Master";
      } else {
        return "";
      }
    },
    getNomeRelacionado(data) {
      if (data.Revenda) {
        return data.Revenda.nome;
      } else if (data.Emitente) {
        return data.Emitente.nome;
      } else if (data.Distribuidor) {
        return data.Distribuidor.nome;
      } else if (data.DistribuidorMaster) {
        return data.DistribuidorMaster.nome;
      } else {
        return "";
      }
    },
    getDocumentoRelacionado(data) {
      if (data.Revenda) {
        return data.Revenda.cnpj;
      } else if (data.Emitente) {
        return data.Emitente.cnpj;
      } else if (data.Distribuidor) {
        return data.Distribuidor.cnpj;
      } else if (data.DistribuidorMaster) {
        return data.DistribuidorMaster.cnpj;
      } else {
        return "";
      }
    },
  },
  async mounted() {
    this.loading = true;
    this.errosValidacao = [];
    this.errosGerais = [];

    try {
      let ret = await this.$store.dispatch(
        "licencaRecebivel/getLicencaRecebivel",
        this.id
      );

      if (ret.Success === true) {
        this.licencaFatura = ret.Data;
        this.licencaFatura.pagamento = new Date().toISOString().split("T")[0];
      }
    } catch (error) {
      console.log(error);
    }

    this.loading = false;
    setTimeout(() => {
      this.nextFocus(`txtDescricao`);
    }, 800);
  },
  data() {
    return {
      errosGerais: [],
      errosValidacao: [],
      loading: false,
      licencaFatura: {},
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style></style>
